import { Message } from 'domain/message/message';
import { MessageOutput } from 'infrastructure/graphql/messaging/message/model/message.output';

export abstract class MessageConverterPort {
	public abstract asMessageEntity(output: MessageOutput): Message;

	public abstract asMessagesEntities(outputs: MessageOutput[]): Message[];
}
